import { FC, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Loader } from 'shared/components/Loader'
import { IApplicationState } from 'redux/store/store'
import { Redirect } from 'react-router'
import { VestigingEnum } from 'shared/models/Enum'
import { IKlant } from 'shared/models/IKlant'
import { IAfleverafspraakLocatieKoppeling } from 'shared/models/IAfleverafspraakLocatieKoppeling'
import { IOrderType } from 'shared/models/IOrderType'
import { ISearchReference } from 'shared/models/References'
import SearchCustomers from './CustomerDeliveryLocationsComponents/SearchCustomers'
import MultipleCustomerData from './CustomerDeliveryLocationsComponents/MultipleCustomerData'
import { CustomerDeliveryLocationsService } from 'services/CustomerDeliveryLocationsService'
import DeliveryLocationAgreementActions from './CustomerDeliveryLocationsComponents/DeliveryLocationAgreementActions'
import { DeliveryLocationsOverviewModel } from 'shared/models/CutomerDeliveryLocations/DeliveryLocationsOverviewModel'
import { CustomerModel } from 'shared/models/CutomerDeliveryLocations/CustomerModel'
import DeliveryLocationsAgreementData, {
  RowType,
} from './CustomerDeliveryLocationsComponents/DeliveryLocationsAgreementData'
import { DeliveryLocationModel } from 'shared/models/CutomerDeliveryLocations/DeliveryLocationModel'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import {
  getPossibleOrderTypesActionCreator,
  ISetPossibleOrderTypesResponseAction,
} from 'redux/store/actions/globalAction'

interface IProps {
  globalVestiging: VestigingEnum
  possibleOrderTypes: IOrderType[]
  loadingPossibleOrderTypes: boolean
  getPossibleOrderTypes: () => Promise<ISetPossibleOrderTypesResponseAction>
}

const CustomerDeliveryLocationsList: FC<IProps> = ({
  globalVestiging,
  possibleOrderTypes,
  loadingPossibleOrderTypes,
  getPossibleOrderTypes,
}) => {
  const service = new CustomerDeliveryLocationsService()

  const searchRef = useRef<ISearchReference>()

  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()

  const [searchResult, setSearchResult] =
    useState<DeliveryLocationsOverviewModel>()
  const [customers, setCustomers] = useState<IKlant[]>()
  const [selectedCustomer, setSelectedCustomer] = useState<CustomerModel>()
  const [activeRow, setActiveRow] = useState<RowType>()
  const [copyRow, setCopyRow] = useState<IAfleverafspraakLocatieKoppeling>()
  const [editLocation, setEditLocation] = useState<DeliveryLocationModel>()
  const [returnedToScreenAfterAction, setReturnedToScreenAfterAction] =
    useState<boolean>()

  const customersFound = (result: DeliveryLocationsOverviewModel) => {
    setErrorMessage(null)
    setSearchResult(result)
    setReturnedToScreenAfterAction(false)
    if (result != null) {
      console.log('result query')
      console.log(result)
      if (result.customers.length == 1) {
        setSelectedCustomer(result.customers[0])
      }
    }
  }

  const clearResults = () => {
    setErrorMessage(null)
    setSelectedCustomer(null)
    setSearchResult(null)
  }

  const onHide = () => {
    setReturnedToScreenAfterAction(true)
  }

  const refresh = () => {
    searchRef.current.search()
  }

  useEffect(() => {
    getPossibleOrderTypes().then(result => {
      if (!result.success) {
        setErrorMessage(result.errorMessage)
      }
    })
  }, [getPossibleOrderTypes])

  const onClickCustomer = (selectedCustomer: CustomerModel) => {
    console.log(selectedCustomer)
    setSelectedCustomer(selectedCustomer)
  }

  return (
    <>
      {globalVestiging === undefined && <Redirect to='/home' />}
      <h2>Overzicht Afleverlocaties Klanten</h2>

      <div>
        {(loading || loadingPossibleOrderTypes) && (
          <div>
            <Loader show={true} />
          </div>
        )}
        <SearchCustomers
          ref={searchRef}
          service={service}
          warehouse={globalVestiging}
          onError={setErrorMessage}
          onInputChanged={() => setCustomers(null)}
          onLoading={setLoading}
          onResult={customersFound}
          clearResults={clearResults}
          returnedAfterAction={returnedToScreenAfterAction}
        />
      </div>
      {!!errorMessage && (
        <div className='alert alert-danger maxedbox'>{errorMessage}</div>
      )}
      {!!searchResult &&
        searchResult.customers != null &&
        searchResult.customers.length > 0 &&
        searchResult.customers[0] != null && (
          <div>
            <MultipleCustomerData
              customers={searchResult.customers}
              onClick={onClickCustomer}
            />
            {selectedCustomer != null && (
              <DeliveryLocationsAgreementData
                customer={selectedCustomer}
                onRowSelected={setActiveRow}
                copyRow={copyRow}
                possibleOrderTypes={possibleOrderTypes}
              />
            )}
            {selectedCustomer != null && (
              <DeliveryLocationAgreementActions
                customer={selectedCustomer}
                service={service}
                warehouse={globalVestiging}
                activeRow={activeRow}
                possibleOrderTypes={possibleOrderTypes}
                onChangeCopy={setCopyRow}
                onError={setErrorMessage}
                onLoading={setLoading}
                onReloadRequired={refresh}
                onEditDeliveryLocation={setEditLocation}
                onHide={onHide}
              />
            )}
          </div>
        )}
    </>
  )
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    globalVestiging: store.globalState.vestiging,
    possibleOrderTypes: store.globalState.possibleGroupLinkOrderTypes,
    loadingPossibleOrderTypes: store.globalState.loadingOrderTypes,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    getPossibleOrderTypes: () => dispatch(getPossibleOrderTypesActionCreator()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerDeliveryLocationsList)
